import { useI18n } from '@dustin-web/microsite-components/src/i18n/use-i18n'
import Icon from '@dustin-web/microsite-components/src/icon'
import useShoppingCart from '@dustin-web/product-components/src/hooks/dataloader/use-shopping-cart'
import ExportCsv from '@cartsite-app/src/utils/export-csv'

const ExportShoppingCartButton = () => {
  const { cartItems } = useShoppingCart()

  const { translate } = useI18n()
  const exportShoppingCart = () => {
    return {
      data: [
        [
          translate('Quantity'),
          translate('Cart_Product_ProductName'),
          translate('ArticleNumber'),
          translate('Cart_ManufacturerPartNumber'),
          translate('Cart_Stock'),
          translate('Cart_PricesExcludeVat'),
          translate('Cart_RowPrice'),
          translate('Notes'),
        ],
        ...cartItems.map(i => {
          const rowTotal = i.quantity * (i.product?.price?.priceExcludingVat || 0)
          const stockQuantity =
            (i.product?.availability?.internalStock?.quantity || 0) +
            (i.product?.availability?.externalStock?.quantity || 0)

          return [
            i.quantity,
            i.product?.displayName,
            i.productErpIdentifier,
            i.product?.manufacturerProductIdentifier,
            stockQuantity,
            i.product?.price?.priceExcludingVat,
            rowTotal,
            i.comment,
          ]
        }),
      ],
    }
  }

  return (
    <ExportCsv onClick={exportShoppingCart} filename="ShoppingCart.csv">
      <button type="button" className="button-stripped u-decoration-none u-mb-0">
        <Icon name="download" className="u-mr-8 i-16" />
        <span>{translate('Cart_Export_csv')}</span>
      </button>
    </ExportCsv>
  )
}

export default ExportShoppingCartButton
